import { waitForUserConfigurationToInitialize } from "client_legacy/ndaw/workspaceAbilitiesStatusProvider";
import { EnvironmentDatabase, IEnvironmentDatabase } from "./Environment";

export async function getEnvironmentDatabase(): Promise<IEnvironmentDatabase> {
	const {
		databaseConfiguration,
		currentUserIdentity
	} = await waitForUserConfigurationToInitialize();

	return new EnvironmentDatabase(
		databaseConfiguration.environmentId,
		currentUserIdentity.userId
	);
}